import {CustomValueError, useDisplayErrorMessages} from "@/utils/errorDisplay";
import {FormattedMessage} from "react-intl";

/** Renders our backend CustomValueError as a localized message with error type aware context translations */
const FormattedCustomValueError: React.FC<{error: CustomValueError}> = ({error}) => {
    const {getMessage} = useDisplayErrorMessages();
    const message = getMessage(error);

    return <FormattedMessage {...message} />;
};

export default FormattedCustomValueError;
